var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#1877F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 20.0188C27.5 15.8684 24.14 12.5 20 12.5C15.86 12.5 12.5 15.8684 12.5 20.0188C12.5 23.6579 15.08 26.688 18.5 27.3872V22.2744H17V20.0188H18.5V18.1391C18.5 16.688 19.6775 15.5075 21.125 15.5075H23V17.7632H21.5C21.0875 17.7632 20.75 18.1015 20.75 18.515V20.0188H23V22.2744H20.75V27.5C24.5375 27.1241 27.5 23.9211 27.5 20.0188Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeFacebook);
export default __webpack_public_path__ + "static/media/Type=Facebook.a6a6a93c21f7d0066a48a6780054e765.svg";
export { ForwardRef as ReactComponent };